<template>
	<ContainerCenter>
		<Logo
			class="text-center mt-4"
			style="height: 50px; position: fixed; top: 0; right: 0; left: 0;"
		/>
		<v-card>
			<v-toolbar
				color="primary"
				dark
				flat
			>
				<v-toolbar-title class="d-flex flex-grow-1">
					{{ loginDeVisitante ? 'Login Visitante' : 'Login' }}
				</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="pb-0">
				<v-form
					ref="form"
					@submit.prevent="logar"
					id="form-registro"
					autocomplete="on"
				>
					<v-slide-y-transition>
						<v-text-field
							v-if="!loginDeVisitante"
							:autofocus="!loginDeVisitante"
							id="cim"
							name="username"
							label="CIM ou e-mail"
							autocomplete="username"
							v-model="registro.login"
							required
							:rules="[ obrigatorio ]"
						/>
					</v-slide-y-transition>

					<v-text-field
						:autofocus="loginDeVisitante"
						id="password"
						name="password"
						:label="!loginDeVisitante ? 'Senha' : 'Palavra Semestral'"
						:type="verSenha ? 'text' : 'password'"
						v-model="registro.senha"
						:append-icon="verSenha ? 'mdi-eye-off' : 'mdi-eye'"
						@click:append="() => verSenha = !verSenha"
						:rules="[ obrigatorio ]"
						:hint="!loginDeVisitante ? 'Primeiro acesso? Use o link enviado ao seu e-mail' : undefined"
					/>
					<div
						v-if="!loginDeVisitante"
						class="text-right"
					>
						<router-link
							:to="{ name: 'esqueci-senha' }"
							class="caption"
						>
							Esqueci minha senha
						</router-link>
					</div>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn
					block
					color="primary"
					type="submit"
					form="form-registro"
					:disabled="carregando"
					:loading="carregando"
				> Entrar </v-btn>
			</v-card-actions>
			<div class="text-center py-2 subtitle-1 text--secondary	">
				<span> {{ loginDeVisitante ? 'Pertence a Somar?' : 'Outra Somar?' }} </span>
				<a
					@click.prevent="loginDeVisitante = !loginDeVisitante"
					style="text-decoration: underline	">
					{{ loginDeVisitante ? 'Entre com o Usuário' : 'Entre como Visitante' }}
				</a>
			</div>
		</v-card>
	</ContainerCenter>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { authModule, alert } from '@/store'
import { éLoginPorEmail, normalizarEmail } from '../../common/shareds/sharedEmail'
import { obrigatorio } from '@/shareds/regras'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { analytics } from '@/firebase'
import Logo from '@/components/ui/Logo.vue'
import { useRoute, useRouter } from '@/composables/router'

const router = useRouter()
const route = useRoute()

const form = ref<HTMLFormElement & {
	validate: () => boolean,
}>()

const verSenha = ref(false)

const registro = ref({
	// vindo da confirmação do e-mail, o login já chega preenchido
	login: typeof route.query.email === 'string' ? route.query.email : '',
	senha: '',
})

const carregando = ref(false)

const loginDeVisitante = computed({
	get: () => route.query.visitante === null,
	set: (valor: boolean) => {
		router.push({
			name: route.name || undefined,
			query: { visitante: valor ? null : undefined },
		})
	},
})

function prosseguir() {
	router.push({ name: authModule.emailPendente || authModule.sugerirEmail ? 'associar-email' : 'home' })
		.catch(() => {})
}

async function logar() {
	if (!form.value!.validate()) return

	try {
		carregando.value = true
		const { senha } = registro.value
		const login = String(registro.value.login).trim()
		if (loginDeVisitante.value)
			await authModule.logar({ login: 'Visitante', senha })
		else if (éLoginPorEmail(login))
			await authModule.logarPeloEmail(normalizarEmail(login), senha)
		else
			await authModule.logarPeloCim({ cim: login, senha })
		prosseguir()
	} catch (error) {
		alert.setError(error)
	} finally {
		carregando.value = false
	}
}

analytics.logEvent('login', prosseguir)
</script>
